import { BlocksImageGalleryItem } from 'blocks-nextjs/blocks-web-components/components/image-gallery-item/image-gallery-item';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatImageGalleryItem = createComponent({
  react: React,
  tagName: 'cat-image-gallery-item',
  elementClass: BlocksImageGalleryItem
});
